import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=478fdbaf&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=478fdbaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478fdbaf",
  null
  
)

export default component.exports